import Box from '@mui/material/Box';
import { keyframes, styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { GearIcon } from '@phosphor-icons/react/Gear';
import { ChatBubbleIcon } from '../../FloatingWidget/ChatBubbleIcon.tsx';

export type ChatAiBubbleVariant = 'default' | 'error';

export type ChatAiBubbleProps = {
  variant?: ChatAiBubbleVariant;
  animate?: boolean;
};

const rotate = keyframes({
  from: {
    transform: 'rotate(0deg)',
  },
  to: {
    transform: 'rotate(360deg)',
  },
});

const StyledGearIcon = styled(GearIcon)`
  position: absolute;
  top: -4px;
  right: -4px;
  width: 12px;
  height: 12px;
  color: ${({ theme }) => theme.palette.primary.dark};
  animation: ${rotate} 2s linear infinite;
`;

export function ChatAiBubble({ variant = 'default', animate = false }: ChatAiBubbleProps) {
  const isError = variant === 'error';

  return (
    <Box
      sx={theme => ({
        position: 'relative',
        marginTop: 0.5,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: isError ? theme.palette.error.light : theme.palette.charts.lavender,
      })}
    >
      <ChatBubbleIcon width={27} height={27} />
      <Typography
        sx={[
          {
            fontSize: 11,
            fontWeight: 'fontWeightBold',
          },
          theme => ({
            position: 'absolute',
            color: isError ? theme.palette.error.main : theme.palette.charts.plum,
            top: '40%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
          }),
        ]}
      >
        AI
      </Typography>
      {animate && <StyledGearIcon />}
    </Box>
  );
}
